import React from 'react'
import Img from 'gatsby-image'
import backImg from '../../images/photo-bg.jpeg'
import styles from './Hero.module.css'

const Hero = () => (
  <div className={styles.hero}>
    {/* <Img className={styles.heroImage} alt="" fluid={fluid} /> */}
    <div
      className={styles.heroImage}
      style={{ backgroundImage: `url(${backImg})` }}
    ></div>

    <div className={styles.heroDetails}>
      {/* <h3 className={styles.heroHeadline}>{data.name}</h3>
          <p className={styles.heroTitle}>{data.title}</p>
          <p>{data.shortBio.shortBio}</p> */}
      <p className={styles.heroTitle}>Shoekicker Guru Blog</p>
      <p>
        We put the spotlight on the best types running shoes for every runner.
        Get the best bang for your buck on neutral, motion control, lightweight,
        and racing shoes. Running shoe reviews, gear tips, and training advice
        from the team at Shoekicker.
      </p>
    </div>
  </div>
)

export default Hero
